export default __webpack_public_path__ + "static/detective-b1e7776e749ff1b3dad8b6816f89e93b.png";